import { Col, Row } from 'antd';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { WorkOrderKitListRequest } from '@/core/domain/workorder/Kits/Kits.types';

function WorkOrderKitListExtraFilter({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<WorkOrderKitListRequest>) {
  return (
    <Row gutter={[12, 12]}>
      <Col span={24} md={12} lg={8} xxl={4}>
        <OrderExtraFilter
          value={queryParams?.order === 1 ? 'ASC' : 'DESC'}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value === 'ASC' ? 1 : 0,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default WorkOrderKitListExtraFilter;
